<template>
    <b-modal ref="viewInfo" size="lg" hide-footer :title="$t('Thông tin đoàn đánh giá')">
        <div class="d-block">
            <div class="row">
                <div class=" col-md-12">
                    <div v-for="(group, key) in groupedData" :key="key">
                        <label for="">{{ key }} :</label>
                        <div class="table-responsive">
                            <table class="table table-hover table-striped">
                                <thead class="thead-light">
                                    <tr>
                                        <th>{{ $t('user.attribute.avatar') }}</th>
                                        <th>{{ $t('user.attribute.organization') }}</th>
                                        <th>{{ $t('user.attribute.position') }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(user, key) in group" :key="key">
                                        <td>
                                            <div class="avatar">
                                                <img class="img-avatar" :src="user.avatar" alt="" />
                                            </div>
                                        </td>
                                        <td>
                                            <div>{{ user.name }}</div>
                                            <div class="small text-muted">
                                                {{ user.email }}
                                            </div>
                                        </td>
                                        <td>{{ user.pos_name }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </b-modal>
</template>
<script>
import { getAssessmentTeam } from '@/service/Apis'
export default {
  name: 'assessmentTeam',
  components: {},
  props: [],
  data () {
    return {
      loading: false,
      groupedData: []
    }
  },
  computed: {
  },
  mounted () {

  },
  methods: {
    async show (checklist) {
      this.$refs.viewInfo.show()
      const res = await getAssessmentTeam(checklist.id)
      this.groupedData = res.data.reduce((acc, item) => {
        if (!acc[item.alias]) {
          acc[item.alias] = []
        }
        acc[item.alias].push(item)
        return acc
      }, {})

      // Sắp xếp mỗi nhóm theo pos_order
      for (const alias in this.groupedData) {
        this.groupedData[alias].sort((a, b) => b.pos_order - a.pos_order)
      }
    }
  }
}
</script>
<style lang="scss"></style>



// WEBPACK FOOTER //
// src/views/checklist/list/assessmentTeam.vue